import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  viewOrder,
  makePayment,
  saveUserAddress,
  savePaymentEvent,
  setPlacingOrder,
} from "../../redux/actionCreators/orderAndPayments"
import "./CheckoutPage.scss"
import "./CreditCardLayout.scss"
import { Form } from "antd"
import { PageHeader } from "../../molecules/PageHeader"
import _, { throttle } from "lodash"
import "../../components/Payment/Payment.scss"
import { fetchPartnerDetails } from "../../redux/actionCreators/invitePeople"
import { DELIVERY_CLIENT_ID } from "../../keys"
import {
  ORDER_LABEL,
  PARTNER_ORDERS,
  PLACE_ORDER_BUTTON,
  PAYMENT_METHOD,
  PAYMENT_FAIL_FEEDBACK,
  CARD_NUMBER_PLACEHOLDER,
  CREDIT_EXPIRE_PLACEHOLDER,
  CARD_CVV_PLACEHOLDER,
  CARD_BILLING_ZIP_PLACEHOLDER,
  GO_BACK_FROM_PAYMENT,
  POWERED_BY,
  YOU_PAY_SELF,
  YOU_PAY_BOTH,
  BACK_FROM_PAYMENT,
  TIP_10,
  TIP_15,
  TIP_20,
  TIP_CASH,
  TIP_CUSTOM,
  TIP,
  AMOUNT,
  GO_BACK_CONTENT,
  PARTNER_PAY_BOTH,
  YOUR,
  OFFLINE,
} from "../../constants/messages"
import {
  FirebaseContext,
  FIREBASE_STATE_KEYS,
  FirebaseService,
} from "../../firebase"
import { usePrevious } from "common-custom-hooks"
import BlockingModal from "../../components/BlockingModal/BlockingModal"
import {
  combineOrders,
  emptyDeliveryDotComCart,
} from "../../redux/actionCreators/planDinnner"
import OrderDetails from "../../components/OrderDetails/OrderDetails"
import { withFormik } from "formik"
import { CardDetailsValidation } from "../../validationSchema/CardDetailsValidation"
import {
  formatCreditCardNumber,
  formatExpirationDate,
} from "../../utils/cardUtils"
import delivery_com_img from "../../assets/images/deliveryTextIcon.png"
import { ArrowLeftOutlined } from "@ant-design/icons"
import { invitePartnerToChat } from "../../redux/actionCreators/invitePeople"
import CheckoutPartnerAway from "./CheckoutPartnerAway"
import {
  getGenderSpecificMessage,
  getPartnerNameorNickName,
  checkCheckoutPartnerAway,
} from "../../utils/helpers"
import { Input, TextTag, Button } from "../../atoms"
import RestaurantNameHeader from "../../components/RestaurantNameHeader/RestaurantNameHeader"
import { PriceBreakdown } from "../../components/OrderDetails/OrderDetails"
import { createCombinedOrderPriceBreakdown } from "../../utils/paymentHelper"
import { ActivityIndicator } from "../../components/ActivityIndicator"
import { goBackToPlanADate } from "./CheckoutUtils"
import {
  ToastMessage,
  NOTIFICATION_TYPES,
} from "../../components/Notification/Notifications"

const CheckoutPaymentPage = props => {
  const {
    viewOrder,
    cartDetailsPartner1,
    cartDetailsPartner2,
    partnerDetails,
    user,
    isLoading,
    fetchPartnerDetails,
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    isSubmitting,
    placingOrder,
    setPlacingOrder,
    isValid,
    dirty,
    returnDisabled,
  } = props

  const myDetails = {}
  const yourDetails = {}
  const [
    userCancellingModalVisibility,
    setuserCancellingModalVisibility,
  ] = useState(false)
  const [isFailed, setFailed] = React.useState(false)

  const { dateState, partnerState, userState } = React.useContext(
    FirebaseContext
  )
  const userUUID = _.get(userState, "userDetails.uuid")
  const showPartnerAway = checkCheckoutPartnerAway(partnerState, dateState)

  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )
  const [value, setValue] = useState(1)
  let paymentMode = ""

  const userOrderId = _.get(userState, FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID)
  const previousAcceptedRestaurant = usePrevious(acceptedRestaurant)
  const [buttonDisabled, setButtonDisabled] = useState(true)

  useEffect(() => {
    const acceptedRestaurantId =
      acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID]
    if (
      acceptedRestaurantId &&
      !_.isEqual(previousAcceptedRestaurant, acceptedRestaurant)
    ) {
      viewOrder(false, acceptedRestaurantId)
      fetchPartnerDetails()
    }
  }, [acceptedRestaurant])

  useEffect(() => {
    if (userOrderId !== undefined) {
      if (payStatus.status === "SELF") {
        FirebaseService.setActiveRoute("/order/success")
        props.history.push("/order/success")
      } else {
        async function _goBackToPlanADate() {
          setPlacingOrder(true)
          await goBackToPlanADate(
            props,
            dateState,
            userState,
            partnerState,
            isCombined
          )
          setPlacingOrder(false)
        }
        _goBackToPlanADate()
      }
    }
  }, [userOrderId])

  const partnerFirebaseCart = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.DELIVERY_COM_CART,
    {}
  )
  const myFirebaseCart = _.get(
    userState,
    FIREBASE_STATE_KEYS.DELIVERY_COM_CART,
    {}
  )
  const combinedPrices = createCombinedOrderPriceBreakdown(
    myFirebaseCart,
    partnerFirebaseCart
  )

  const partnerName = getPartnerNameorNickName(partnerState)

  const status = _.get(dateState, "payStatus")
    ? _.get(dateState.payStatus, "status", "")
    : ""
  const me = _.get(props, "user.username", "")
  const isPayingForBoth =
    _.get(dateState, "payStatus.userPickedTab") === _.get(user, "uuid", "") &&
    status === "BOTH"
  const isCombined = status === "COMBINED"
  const myCart =
    _.get(user, "username") === _.get(partnerDetails, "partner1.username")
      ? cartDetailsPartner1
      : cartDetailsPartner2
  const partnerCart =
    _.get(user, "username") === _.get(partnerDetails, "partner1.username")
      ? cartDetailsPartner2
      : cartDetailsPartner1

  const deliveryFee = isPayingForBoth
    ? _.get(myCart, "delivery_fee", 0) + _.get(partnerCart, "delivery_fee", 0)
    : _.get(myCart, "delivery_fee", 0)
  const totalOrder = isPayingForBoth
    ? _.get(myCart, "total", 0) + _.get(partnerCart, "total", 0)
    : _.get(myCart, "total", 0)

  const grandSubTotal = isPayingForBoth
    ? _.get(myCart, "subtotal", 0) + _.get(partnerCart, "subtotal", 0)
    : _.get(myCart, "subtotal", 0)

  const tipOptions = [
    {
      label: TIP_10,
      value: (isCombined ? combinedPrices.subtotal : grandSubTotal) * 0.1,
      percent: 0.1,
    },
    {
      label: TIP_15,
      value: (isCombined ? combinedPrices.subtotal : grandSubTotal) * 0.15,
      percent: 0.15,
    },
    {
      label: TIP_20,
      value: (isCombined ? combinedPrices.subtotal : grandSubTotal) * 0.2,
      percent: 0.2,
    },
    { label: TIP_CUSTOM, value: "show" },
    { label: TIP_CASH },
  ]
  const [selectedTip, setSelectedTip] = useState(0)
  const [selectedTipPercent, setSelectedTipPercent] = useState(0)
  const [manualTipValue, setManualTipValue] = useState(0)
  const [isManualTip, setIsManualTip] = useState(false)

  const tipValue = isManualTip ? manualTipValue : selectedTip
  const partnerPayStatus = _.get(
    dateState,
    `${FIREBASE_STATE_KEYS.PAY_STATUS}.${FIREBASE_STATE_KEYS.STATUS}`
  )

  const payStatus = _.get(dateState, `${FIREBASE_STATE_KEYS.PAY_STATUS}`)
  const partnerOrderId = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID
  )
  const combinedTotal =
    _.get(myCart, "total", 0) + _.get(partnerCart, "total", 0)
  const partner1 = _.get(partnerDetails, "partner1")
  const partner2 = _.get(partnerDetails, "partner2")
  if (
    _.get(partnerDetails, "partner1.username", "") ===
    _.get(user, "username", "")
  ) {
    myDetails["cart"] = cartDetailsPartner1
    myDetails["displayName"] = _.get(user, "display_name", "")
    myDetails["last_name"] = _.get(partner1, "last_name", "")
    yourDetails["cart"] = cartDetailsPartner2
    yourDetails["displayName"] = (partner2 && partner2.display_name) || ""
    yourDetails["last_name"] = (partner2 && partner2.last_name) || ""
  } else {
    myDetails["cart"] = cartDetailsPartner2
    myDetails["displayName"] = (user && user.display_name) || ""
    myDetails["last_name"] = (partner2 && partner2.last_name) || ""
    yourDetails["cart"] = cartDetailsPartner1
    yourDetails["displayName"] = (partner1 && partner1.display_name) || ""
    yourDetails["last_name"] = (partner1 && partner1.last_name) || ""
  }

  let partner = {}

  if (_.get(partnerDetails, "partner1.username", "") === me) {
    partner = _.get(partnerDetails, "partner2")
  } else {
    partner = _.get(partnerDetails, "partner1")
  }

  const total = totalOrder

  const formatValue = values => {
    return {
      ...values,
      tip: tipValue,
      cardNumber: values.cardNumber.toString().replace(/ /g, ""),
    }
  }

  const findPaidBy = () => {
    let paidByDetails = {}
    if (payStatus.status === "BOTH" || payStatus.status === "COMBINED")
      payStatus.userPickedTab === _.get(userState, "userDetails.uuid")
        ? (paidByDetails = {
            user: _.get(userState, "userDetails.username"),
            status: payStatus.status,
          })
        : (paidByDetails = {
            user: _.get(partnerState, "userDetails.username"),
            status: payStatus.status,
          })
    else if (payStatus.status === "SELF")
      paidByDetails = {
        user: _.get(userState, "userDetails.username"),
        status: payStatus.status,
      }
    return paidByDetails
  }

  const getServiceFee = arr => {
    let fee = 0
    if (arr.length !== 0) {
      arr.map((feeItem, index) => {
        if (feeItem.name === "Service Charge")
          fee = _.get(feeItem, "value").toFixed(2)
      })
    }
    return Number(fee)
  }
  const getDeliveryFee = arr => {
    let fee = 0
    if (arr.length !== 0) {
      arr.map((feeItem, index) => {
        if (feeItem.name === "Delivery Fee") {
          fee = _.get(feeItem, "value").toFixed(2)
        }
      })
    }
    return Number(fee)
  }

  const calculateTipForAdminDashboard = (payStatus, cart) => {
    let tip = 0
    if (payStatus.status === "BOTH")
      tip = getIndividualTipValue(_.get(cart, "subtotal"))
    else tip = getTipValue()
    return Number((tip || 0).toFixed(2))
  }

  const findOrderCost = cart => {
    let orderCostBreakUp = {}
    const myFirebaseCart = _.get(
      userState,
      `${FIREBASE_STATE_KEYS.DELIVERY_COM_CART}`
    )
    const partnerFirebaseCart = _.get(
      partnerState,
      `${FIREBASE_STATE_KEYS.DELIVERY_COM_CART}`
    )
    if (payStatus.status === "COMBINED") {
      const priceBreakdown = createCombinedOrderPriceBreakdown(
        myFirebaseCart,
        partnerFirebaseCart
      )
      orderCostBreakUp = {
        delivery_fee: _.get(priceBreakdown, "delivery_fee").toFixed(2),
        service_charge: _.get(priceBreakdown, "service_fee").toFixed(2),
        tax: _.get(priceBreakdown, "tax").toFixed(2),
        discount: _.get(priceBreakdown, "discount").toFixed(2),
        tip: calculateTipForAdminDashboard(payStatus, cart),
        total: Number(
          calculateTotal(isCombined, combinedTotal, total).toFixed(2)
        ),
        fullCartTotal: calculateTotal(isCombined, combinedTotal, total).toFixed(
          2
        ),
      }
    } else if (payStatus.status === "SELF" || payStatus.status === "BOTH") {
      orderCostBreakUp = {
        delivery_fee: getDeliveryFee(_.get(cart, "fees")),
        service_charge: getServiceFee(_.get(cart, "fees")),
        tax: _.get(cart, "tax", 0).toFixed(2),
        discount: _.get(cart, "discount").toFixed(2),
        tip: calculateTipForAdminDashboard(payStatus, cart),
        total:
          Number(_.get(cart, "grand_total").toFixed(2)) +
          calculateTipForAdminDashboard(payStatus, cart),
        fullCartTotal:
          payStatus.status === "BOTH"
            ? calculateTotal(isCombined, combinedTotal, total).toFixed(2)
            : _.get(cart, "grand_total").toFixed(2),
      }
    }
    return orderCostBreakUp
  }

  const getIndividualTipValue = total => {
    if (tipValue <= 0) {
      return
    }
    const tip = isManualTip ? tipValue / 2 : selectedTipPercent * total
    return Number(tip)
  }

  const _makePayment = async () => {
    const _values = formatValue(values)
    const userUUID = _.get(userState, "userDetails.uuid")
    const partnerUUID = _.get(partnerState, "userDetails.uuid")
    const userInfo = _.get(dateState, `payStatus.${userUUID}`, {})
    const partnerInfo = _.get(dateState, `payStatus.${partnerUUID}`, {})
    const restaurantId = _.get(
      props,
      "cartDetailsPartner1.merchant_info.id",
      ""
    )
    // start the loader only if user is online; else show a notification and return
    if (navigator.onLine) {
      setPlacingOrder(true)
    } else {
      setPlacingOrder(false)
      const throttleToastMessage = throttle(ToastMessage, 5000)
      throttleToastMessage({
        type: NOTIFICATION_TYPES.ERROR,
        message: OFFLINE,
      })
      return
    }

    if (isCombined) {
      await props.combineOrders(
        restaurantId,
        _.get(myFirebaseCart, "cart", {}),
        _.get(partnerFirebaseCart, "cart", {})
      )
    }
    if (_values.cardNumber.length > 16)
      _values.cardNumber = _values.cardNumber.substring(
        0,
        _values.cardNumber.length - 1
      )

    _values.first_name = _.get(userInfo, "firstName", "")
    _values.last_name = _.get(userInfo, "lastName", "")
    _values.email = _.get(userInfo, "paymentEmail", "")
    _values.phone_number = _.get(userInfo, "paymentPhone", "")

    const restaurantName = _.get(acceptedRestaurant, "restaurantName", "")
    const myAddress = _.get(props, "user.address.user_address", "")
    const partnerAddress = _.get(partner, "address.user_address", "")
    const partnerPhoneNumber = _.get(partnerInfo, "paymentPhone", "")
    const partnerEmail = _.get(partnerInfo, "paymentEmail", "")
    const partnerFirstName = _.get(partnerInfo, "firstName", "")
    const partnerLastName = _.get(partnerInfo, "lastName", "")

    const { expiryDate, CVV, paymentMode, billingZip } = values
    const guestToken = _.get(props, "user.delivery_guest_token")
    const combinedOrderGuestToken = _.get(
      partnerDetails,
      "delivery_guest_token"
    )
    const partnerToken = _.get(props, "partner.delivery_guest_token")
    //to save to admin dashboard
    const myCartItems = []
    const partnerItems = []
    for (const cart of myCart.cart) {
      const detail = {
        item_name: cart["name"],
        item_qty: cart["quantity"],
        item_price: cart["price"],
      }
      myCartItems.push(detail)
    }
    for (const cart of partnerCart.cart) {
      const detail = {
        item_name: cart["name"],
        item_qty: cart["quantity"],
        item_price: cart["price"],
      }
      partnerItems.push(detail)
      if (payStatus.status === "COMBINED") myCartItems.push(detail)
    }

    let tip = {}
    let addedTip = false
    if (isManualTip) {
      tip = { fixed: tipValue }
      addedTip = true
    } else if (selectedTip) {
      tip = { percent: selectedTipPercent }
      addedTip = true
    }

    const _tipValue = calculateTipForAdminDashboard(payStatus, myCart)
    const _partnerTipValue = calculateTipForAdminDashboard(
      payStatus,
      partnerCart
    )

    const payload = [
      {
        order_type: "delivery",
        order_time: "ASAP",
        first_name: _values.first_name,
        last_name: _values.last_name,
        sms_notify: "true",
        isOptingIn: "true",
        address: myAddress,
        merchant_id: restaurantId,
        email: _values.email,
        phone_number: _values.phone_number,
        client_id: DELIVERY_CLIENT_ID,
        guest_token: isCombined ? combinedOrderGuestToken : guestToken,
        tip: tip,
        addedTip: addedTip,
        tipValue: _tipValue,
        user_id: _.get(props, "user.uuid"), //for admin dashboard only
        total: _.get(myCart, "total", 0).toFixed(2), //for admin dashboard only
        merchant: restaurantName, //for admin dashboard only
        ordered_items: myCartItems, //for admin dashboard only
        merchant_address: acceptedRestaurant.restaurantAddress, //for admin dashboard only
        paidBy: findPaidBy(), //for admin dashboard only
        orderCost: findOrderCost(myCart), //for admin dashboard only
      },
    ]

    if (isPayingForBoth) {
      payload.push({
        order_type: "delivery",
        order_time: "ASAP",
        first_name: partnerFirstName,
        last_name: partnerLastName,
        sms_notify: "true",
        isOptingIn: "true",
        address: partnerAddress,
        merchant_id: restaurantId,
        email: partnerEmail,
        phone_number: partnerPhoneNumber,
        client_id: DELIVERY_CLIENT_ID,
        guest_token: partnerToken,
        tip: tip,
        addedTip: addedTip,
        tipValue: _partnerTipValue,
        user_id: _.get(props, "partner.uuid"),
        total: _.get(partnerCart, "total", 0),
        merchant: restaurantName,
        ordered_items: partnerItems,
        merchant_address: acceptedRestaurant.restaurantAddress,
        paidBy: findPaidBy(),
        orderCost: findOrderCost(partnerCart), //for admin dashboard only
        partnerUUID: _.get(partner, "uuid", ""),
      })
    }

    const [expMonth, expYear] = expiryDate.split("/")

    let payments = {}

    if (paymentMode === "credit_card") {
      let removedSpace = _values.cardNumber.toString().replace(/ /g, "")
      payments = [
        {
          type: "credit_card",
          card: {
            cc_number: removedSpace,
            cvv: CVV,
            exp_month: expMonth,
            exp_year: `20${expYear}`,
            billing_zip: billingZip,
            save: false,
          },
        },
      ]
    } else {
      payments = {
        type: "cash",
      }
    }

    for (const item of payload) {
      item["payments"] = payments
    }
    await props.makePayment(payload, isPayingForBoth, isCombined)
    const saveDatePayload = {
      partner1: _.get(props, "user.username"),
      partner2: partnerEmail,
      partner1Location: myAddress,
      partner2Location: partnerAddress,
      date: new Date(),
      paidBy: _.get(props, "user.username"),
      restaurantId: restaurantId,
    }
    await props.savePaymentEvent(saveDatePayload)
    if (partnerPayStatus === "SELF" && partnerOrderId) {
      await props.emptyDeliveryDotComCart(
        acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
        false,
        isCombined,
        isPayingForBoth
      )
    }
    setPlacingOrder(false)
  }

  const navigateToCheckoutDetailPage = async () => {
    if (
      dateState &&
      dateState.payStatus &&
      (dateState.payStatus.status === "BOTH" ||
        dateState.payStatus.status === "COMBINED")
    ) {
      setuserCancellingModalVisibility(true)
    } else {
      FirebaseService.write(
        {
          ...props.date.payStatus,
          [userUUID]: {
            state: "CONFIRM",
          },
        },
        `${FirebaseService.getDefaultPath()}${[FIREBASE_STATE_KEYS.PAY_STATUS]}`
      )
      await FirebaseService.setActiveRoute("/checkout/detail")
      props.history.push("/checkout/detail")
    }
  }

  const getTipValue = () => {
    if (tipValue <= 0) {
      return
    }
    const tip = parseFloat(tipValue)
    return Number(tip)
  }

  const calculateTotal = (isCombined, combinedTotal, total) => {
    const tip = getTipValue() || 0
    const partnerFirebaseCart = _.get(
      partnerState,
      FIREBASE_STATE_KEYS.DELIVERY_COM_CART,
      {}
    )
    const myFirebaseCart = _.get(
      userState,
      FIREBASE_STATE_KEYS.DELIVERY_COM_CART,
      {}
    )
    const combinedPrices = createCombinedOrderPriceBreakdown(
      myFirebaseCart,
      partnerFirebaseCart
    )
    // total values are coming as string Tofixed will break it.
    if (isCombined) {
      let value = parseFloat(combinedPrices.total)
      return tip + value
    }

    let totalValue = parseFloat(total)
    return tip + totalValue
  }

  const showBlockingModal = () => {
    return (
      <BlockingModal
        withOptions
        title={GO_BACK_FROM_PAYMENT}
        content={GO_BACK_CONTENT(partnerName)}
        blockingModalVisibility={userCancellingModalVisibility}
        continueHandler={async () => {
          await FirebaseService.write(
            {
              ...props.date.payStatus,
              [userUUID]: { state: "CHECKOUT" },
              status: "CANCELLED",
            },
            `${FirebaseService.getDefaultPath()}${[
              FIREBASE_STATE_KEYS.PAY_STATUS,
            ]}`
          )
          setuserCancellingModalVisibility(false)
          await FirebaseService.setActiveRoute("/checkout")
          props.history.push("/checkout")
        }}
        cancelHandler={() => setuserCancellingModalVisibility(false)}
      />
    )
  }

  const getCardDetails = () => {
    const returnDisabled = disableValue => {
      setButtonDisabled(disableValue)
    }
    const cardDetails = (
      <div id="checkoutCardBox">
        <Form.Item
          validateStatus={
            touched.cardNumber && errors.cardNumber ? "error" : undefined
          }
        >
          <Input
            className="credit-input"
            type="text"
            onChange={e => {
              handleChange(e)
              returnDisabled(
                value === 1 ? isSubmitting || !isValid || !dirty : false
              )
            }}
            onBlur={handleBlur}
            value={formatCreditCardNumber(values.cardNumber, 4)}
            name="cardNumber"
            placeholder={CARD_NUMBER_PLACEHOLDER}
            error={
              touched.cardNumber && errors.cardNumber ? errors.cardNumber : ""
            }
          />
        </Form.Item>
        <div className="security-row">
          <div className="expiry-col">
            <Form.Item
              validateStatus={
                touched.expiryDate && errors.expiryDate ? "error" : undefined
              }
            >
              <Input
                className="expiry"
                type="text"
                onChange={e => {
                  handleChange(e)
                  returnDisabled(
                    value === 1 ? isSubmitting || !isValid || !dirty : false
                  )
                }}
                onBlur={handleBlur}
                value={formatExpirationDate(values.expiryDate)}
                name="expiryDate"
                placeholder={CREDIT_EXPIRE_PLACEHOLDER}
                error={
                  touched.expiryDate && errors.expiryDate
                    ? errors.expiryDate
                    : ""
                }
              />
            </Form.Item>
          </div>
          <div className="cvv-col">
            <Form.Item
              validateStatus={touched.CVV && errors.CVV ? "error" : undefined}
            >
              <Input
                className="cvv-info"
                type="password"
                onChange={e => {
                  if (isNaN(Number(e.target.value))) {
                    return
                  } else {
                    handleChange(e)
                    returnDisabled(
                      value === 1 ? isSubmitting || !isValid || !dirty : false
                    )
                  }
                }}
                onBlur={handleBlur}
                value={values.CVV}
                name="CVV"
                placeholder={CARD_CVV_PLACEHOLDER}
                error={touched.CVV && errors.CVV ? errors.CVV : ""}
              />
            </Form.Item>
          </div>
        </div>
        <Form.Item
          validateStatus={
            touched.billingZip && errors.billingZip ? "error" : undefined
          }
        >
          <Input
            className="credit-input"
            type="text"
            onChange={e => {
              if (isNaN(Number(e.target.value))) {
                return
              } else {
                handleChange(e)
                returnDisabled(
                  value === 1 ? isSubmitting || !isValid || !dirty : false
                )
              }
            }}
            autocomplete="off"
            onBlur={handleBlur}
            value={values.billingZip}
            name="billingZip"
            placeholder={CARD_BILLING_ZIP_PLACEHOLDER}
            error={
              touched.billingZip && errors.billingZip ? errors.billingZip : ""
            }
          />
        </Form.Item>
      </div>
    )
    return cardDetails
  }

  const showPageHeader = () => {
    const partnerGender = getGenderSpecificMessage(
      _.get(partnerState, "userDetails.gender")
    )
    return (
      <PageHeader
        onClick={() => navigateToCheckoutDetailPage()}
        disabled={showPartnerAway}
        btnSize="small"
        icon={<ArrowLeftOutlined />}
        btnText={BACK_FROM_PAYMENT}
        headerText={
          dateState &&
          dateState.payStatus &&
          dateState.payStatus.status === "SELF"
            ? YOU_PAY_SELF
            : _.get(dateState, "payStatus.userPickedTab") ===
              _.get(user, "uuid")
            ? YOU_PAY_BOTH
            : dateState
            ? PARTNER_PAY_BOTH(partnerName, partnerGender)
            : ""
        }
      />
    )
  }

  const paymentLeftPart = () => {
    return (
      <div className="payment-card">
        <div id="payment">
          <div id="paymentDetails">
            <div>
              <div className="payment-method">
                <div className="sub-heading">{PAYMENT_METHOD}</div>
                <hr />
                {isFailed && (
                  <div className="fail-message">{PAYMENT_FAIL_FEEDBACK}</div>
                )}
              </div>
            </div>
            <div id="cardDetailsContainer">
              <div id="cardInput">{paymentMode}</div>
            </div>
          </div>
          {renderTip()}
        </div>
      </div>
    )
  }

  const getPaymentContent = () => {
    if (value === 1) {
      paymentMode = getCardDetails()
    } else if (value === 2) {
      paymentMode = "Go ahead click place your order"
    }

    return (
      <React.Fragment>
        <CheckoutPartnerAway {...props} />
        {showBlockingModal()}
        <div className="order-receipt">
          {showPageHeader()}
          <RestaurantNameHeader restaurants={props.restaurants} />
          <div className="payment-container">
            <form onSubmit={_makePayment}>
              <div className="payment-div">
                {paymentLeftPart()}
                {paymentRightPart()}
              </div>
              {renderPlaceOrderSection()}
            </form>
          </div>
        </div>
      </React.Fragment>
    )
  }

  const renderTip = () => {
    return (
      <div className="tips">
        <div className="tip-label">
          <TextTag>{TIP}</TextTag>
        </div>
        <RadioButtonCustom
          tipOptions={tipOptions}
          setSelectedTip={setSelectedTip}
          setSelectedTipPercent={setSelectedTipPercent}
          selectedTip={selectedTip}
          setManualTipValue={setManualTipValue}
          manualTipValue={manualTipValue}
          setIsManualTip={setIsManualTip}
          isManualTip={isManualTip}
        />
      </div>
    )
  }

  const renderPlaceOrderSection = () => {
    const grandTotal = calculateTotal(isCombined, combinedTotal, total)
    return (
      <div className="place-order">
        <Button
          btnType="primary"
          btnSize="large"
          onClick={_makePayment}
          className="login-form-button"
          disabled={placingOrder || !isValid || !dirty}
        >
          {placingOrder && <ActivityIndicator />}
          {PLACE_ORDER_BUTTON(grandTotal.toFixed(2))}
        </Button>
        <div className="delivery">
          {POWERED_BY}
          <img src={delivery_com_img} alt="delivery.com" />
        </div>
      </div>
    )
  }

  const paymentRightPart = () => {
    const partnerFirebaseCart = _.get(
      partnerState,
      FIREBASE_STATE_KEYS.DELIVERY_COM_CART,
      {}
    )
    const myFirebaseCart = _.get(
      userState,
      FIREBASE_STATE_KEYS.DELIVERY_COM_CART,
      {}
    )
    const grandTotal = calculateTotal(isCombined, combinedTotal, total)
    return (
      <div className="checkout-order">
        <TextTag className="name-heading">{ORDER_LABEL}</TextTag>
        {isCombined || isPayingForBoth
          ? renderPaymentCombinedView(myFirebaseCart, partnerFirebaseCart)
          : renderMyOrderView(myFirebaseCart)}
        <div className="payable-amount">
          <p>Total</p>
          <p>{`$ ${grandTotal.toFixed(2)}`}</p>
        </div>
      </div>
    )
  }

  const renderPaymentCombinedView = (myFirebaseCart, partnerFirebaseCart) => {
    const combinedPrices = createCombinedOrderPriceBreakdown(
      myFirebaseCart,
      partnerFirebaseCart
    )
    const tip = getTipValue() || 0

    return (
      <div className="combined-order-content">
        <div className="orderer-name">You</div>
        <OrderDetails
          cart={myFirebaseCart.cart}
          isPayingForBoth={isPayingForBoth}
          isOrderCombined={isCombined}
          name={YOUR}
          subtotal={_.get(myFirebaseCart, "subtotal", 0)}
        />
        {isPayingForBoth && (
          <PriceBreakdown
            {...myFirebaseCart}
            name={YOUR}
            isPayingForBoth={isPayingForBoth}
          />
        )}
        <div className="partner-name">
          {PARTNER_ORDERS(yourDetails["displayName"])}
        </div>
        <OrderDetails
          cart={partnerFirebaseCart.cart}
          isPayingForBoth={isPayingForBoth}
          isOrderCombined={isCombined}
          name={`${PARTNER_ORDERS(yourDetails["displayName"])}'s`}
          subtotal={_.get(partnerFirebaseCart, "subtotal", 0)}
        />
        {isPayingForBoth && (
          <PriceBreakdown
            {...partnerFirebaseCart}
            name={`${PARTNER_ORDERS(yourDetails["displayName"])}'s`}
            isPayingForBoth={isPayingForBoth}
          />
        )}
        {isCombined && (
          <PriceBreakdown
            {...combinedPrices}
            isOrderCombined={isCombined}
            customOrderWrapperClass="single-view"
          />
        )}
        {tip > 0 && (
          <div className="tip-wrapper">
            <span>Tip</span>
            <span>${`${tip.toFixed(2)}`}</span>
          </div>
        )}
      </div>
    )
  }

  const renderMyOrderView = myFirebaseCart => {
    const tip = getTipValue() || 0
    return (
      <div className="order-details">
        <OrderDetails
          cart={myFirebaseCart.cart}
          customOrderWrapperClass="single-view"
        />
        <PriceBreakdown
          {...myFirebaseCart}
          isOrderCombined={isCombined}
          customOrderWrapperClass="single-view"
        />
        {tip > 0 && (
          <div className="tip-wrapper">
            <span>Tip</span>
            <span>${`${tip.toFixed(2)}`}</span>
          </div>
        )}
      </div>
    )
  }

  return (
    <div id="CheckoutPage">
      {isLoading ? <ActivityIndicator /> : getPaymentContent()}
    </div>
  )
}

const RadioButtonCustom = props => {
  const {
    tipOptions,
    setSelectedTip,
    setSelectedTipPercent,
    setManualTipValue,
    setIsManualTip,
    isManualTip,
    manualTipValue,
  } = props

  const onChangeValue = (e, percent) => {
    setSelectedTip(e.target.value)
    setIsManualTip(false)
    setSelectedTipPercent(percent)
    if (e.target.value === tipOptions[3].value) {
      setManualTipValue(0)
      setIsManualTip(true)
    }
  }
  const radioItems = tipOptions.map((item, index) => (
    <div
      className={`radio-item ${
        item.label === TIP_CUSTOM ? "tip-align-row" : ""
      }`}
    >
      <input
        id={index}
        type="radio"
        value={item.value}
        name="gender"
        onChange={e => onChangeValue(e, _.get(item, "percent", 0))}
      />
      <label htmlFor={index}>{item.label}</label>
      {isManualTip && item.label === TIP_CUSTOM && (
        <div className="manual-tip-row">
          <Input
            placeholder={AMOUNT}
            className="manual-tip"
            onChange={e => {
              var rm = e.target.value.replace("$", "")
              const currentVal = parseInt(rm)
              if (isNaN(Number(currentVal))) {
                setManualTipValue(0)
                return
              }
              setManualTipValue(currentVal)
            }}
            value={`$${manualTipValue}`}
          />
        </div>
      )}
    </div>
  ))
  return <div className="radio-group">{radioItems}</div>
}

const PaymentForm = withFormik({
  validationSchema: CardDetailsValidation,
  mapPropsToValues: () => ({
    paymentMode: "credit_card",
    cardNumber: "",
    expiryDate: "",
    CVV: "",
    billingZip: "",
  }),
  handleSubmit: (payload, isPayingForBoth, { props }) => {
    // props.makePayment(payload, isPayingForBoth)
  },
})(CheckoutPaymentPage)

const mapStateToProps = state => {
  const {
    orderAndPayments: {
      cartDetailsPartner1,
      cartDetailsPartner2,
      isLoading,
      payStatus,
      partnerConfirmedCheckoutDetails,
      checkoutHeaderMessage,
      paymentStatus,
      paymentDetails,
    },
    loadingState: { placingOrder },
    planDinner: { restaurantSuggested, restaurants },
    invitePeople: { partnerDetails },
    auth: { user },
    auth: { partner },
  } = state
  return {
    cartDetailsPartner1,
    cartDetailsPartner2,
    restaurantSuggested,
    partnerDetails,
    user,
    partner,
    isLoading,
    payStatus,
    placingOrder,
    partnerConfirmedCheckoutDetails,
    checkoutHeaderMessage,
    paymentStatus,
    paymentDetails,
    restaurants,
  }
}
export default connect(mapStateToProps, {
  viewOrder,
  makePayment,
  saveUserAddress,
  invitePartnerToChat,
  fetchPartnerDetails,
  savePaymentEvent,
  setPlacingOrder,
  combineOrders,
  emptyDeliveryDotComCart,
})(PaymentForm)
